import React, { memo, useState } from '../../../lib/teact/teact';

import buildClassName from '../../../util/buildClassName';
import { getChainTitle } from '../../../util/chain';

import useHistoryBack from '../../../hooks/useHistoryBack';
import useLang from '../../../hooks/useLang';
import useLastCallback from '../../../hooks/useLastCallback';
import useScrolledState from '../../../hooks/useScrolledState';

import SafetyRulesContent from '../../common/backup/SafetyRulesContent';
import SettingsHeader from '../SettingsHeader';

import settingsStyles from '../Settings.module.scss';
import styles from './Backup.module.scss';

interface OwnProps {
  isActive?: boolean;
  isInsideModal?: boolean;
  backupType: 'key' | 'words';
  onBackClick: NoneToVoidFunction;
  onSubmit: NoneToVoidFunction;
}

function BackupSafetyRules({
  isActive,
  backupType,
  onBackClick,
  onSubmit,
}: OwnProps) {
  const lang = useLang();

  const [writedownAccepted, setWritedownAccepted] = useState(false);
  const [openWalletAccepted, setOpenWalletAccepted] = useState(false);
  const [canBeStolenAccepted, setCanBeStolenAccepted] = useState(false);

  const handleBackClick = useLastCallback(() => {
    setWritedownAccepted(false);
    setOpenWalletAccepted(false);
    setCanBeStolenAccepted(false);
    onBackClick();
  });

  useHistoryBack({
    isActive,
    onBack: onBackClick,
  });

  const {
    handleScroll: handleContentScroll,
    isScrolled,
  } = useScrolledState();

  return (
    <div className={settingsStyles.slide}>
      <SettingsHeader title={lang('Safety Rules')} isScrolled={isScrolled} onBackClick={handleBackClick} />
      <div
        className={buildClassName(settingsStyles.content, styles.content)}
        onScroll={handleContentScroll}
      >
        <SafetyRulesContent
          isActive={isActive}
          isFullSizeButton
          textFirst={lang(
            backupType === 'key'
              ? '$safety_rules_private_key_one'
              : '$safety_rules_one',
            { chain: getChainTitle('ton') },
          )}
          textSecond={lang(
            backupType === 'key'
              ? '$safety_rules_private_key_two'
              : '$safety_rules_two',
          )}
          textThird={lang(
            backupType === 'key'
              ? '$safety_rules_private_key_three'
              : '$safety_rules_three',
          )}
          isFirstCheckboxSelected={writedownAccepted}
          onFirstCheckboxClick={setWritedownAccepted}
          isSecondCheckboxSelected={openWalletAccepted}
          onSecondCheckboxClick={setOpenWalletAccepted}
          isThirdCheckboxSelected={canBeStolenAccepted}
          onThirdCheckboxClick={setCanBeStolenAccepted}
          onSubmit={onSubmit}
        />
      </div>
    </div>
  );
}

export default memo(BackupSafetyRules);
